import { useQuery } from '@tanstack/vue-query'
import { httpRequest } from '@shared/api/httpRequests'
import { urlSubst } from '@shared/utils/url'

/**
 * @constant {string} BASE_URL Base URL path
 */
const BASE_URL = '/SystemData/api/v1'

/**
 * @constant {Object.<string:string>} API Map of API CRUD methods and their relative URLs (not including BASE_URL)
 */
export const API = {
  GET_INTEGRATION_SETTING: '/integration-setting/:group/:key',
  GET_SITE_CONTENT: '/site-content/:name',
}
/**
 * @constant {Object.<string:string>} SYSTEM_DATA_API Map of API CRUD methods and their URLs (including BASE_URL)
 */
export const SYSTEM_DATA_API = Object.fromEntries(
  Object.entries(API).map(([key, val]) => [key, `${BASE_URL}${val}`]),
)
SYSTEM_DATA_API.GET_NAVIGATION = '/navigation/api/v1/main-menu'
SYSTEM_DATA_API.GET_USER = '/user/api/v1/me'
//

export function getIntegrationSetting (group, key, queryOptions = {}) {
  const queryKey = [API.GET_INTEGRATION_SETTING]
  const queryFn = async () => await httpRequest({
    baseURL: BASE_URL,
    url: urlSubst(API.GET_INTEGRATION_SETTING, { group, key }),
  })
  return useQuery({ queryKey, queryFn, ...queryOptions })
}

export function getNavigation () {
  const queryKey = [SYSTEM_DATA_API.GET_NAVIGATION]
  const queryFn = async () => await httpRequest({
    url: SYSTEM_DATA_API.GET_NAVIGATION,
  })
  return useQuery({ queryKey, queryFn })
}

export function getSiteContent (name, queryOptions = {}, contentType = 'text/html') {
  // name is required on the queryKey since we might need to use multiple `getSiteContent` in the same view
  // and TanStack will perform only the first one if the queryKey is the same
  const queryKey = [API.GET_SITE_CONTENT, name]
  const queryFn = async () => await httpRequest({
    headers: {
      Accept: contentType,
    },
    baseURL: BASE_URL,
    url: urlSubst(API.GET_SITE_CONTENT, { name }),
  })
  return useQuery({ queryKey, queryFn, ...queryOptions })
}

// helper alias for getting JSON site content
export function getSiteConfig (name, queryOptions = {}, contentType = 'application/json') {
  return getSiteContent(name, queryOptions, contentType)
}

export function getUser () {
  const queryKey = [SYSTEM_DATA_API.GET_USER]
  const queryFn = async () => await httpRequest({
    url: SYSTEM_DATA_API.GET_USER,
  })
  return useQuery({ queryKey, queryFn })
}
